import { Schema } from "effect"
import { Millis, UserId } from "../ids"

// #region chat-signals
/**
 * Wave E (decision 0063): several people in one agent's chat. The body sends these on the Agents SDK chat socket as
 * custom frames `{ type: "minga.signal", signal }`. Every user id is server-stamped from the socket; nothing a client
 * sends names a person.
 */
export const ChatSignal = Schema.TaggedUnion({
  /** Someone is typing (server-stamped; at most one every 3 s per person). */
  typing: { userId: UserId, at: Millis },
  /** Who has this agent's chat open now (one entry per person). */
  here: { userIds: Schema.Array(UserId) },
  /** The turn line: "Lea is answering Becky · yours is next". */
  turn: {
    /** `waiting`: the agent's assigned runner is away. */
    state: Schema.Literals(["answering", "waiting", "idle"]),
    askedBy: Schema.NullOr(UserId),
    /** The next turns' askers, in order; null = the agent's own work. */
    queuedFor: Schema.Array(Schema.NullOr(UserId)),
  },
})
export type ChatSignal = typeof ChatSignal.Type

/** Server → client chat frame carrying a `ChatSignal`. */
export const ChatSignalFrame = Schema.Struct({ type: Schema.Literal("minga.signal"), signal: ChatSignal })
export type ChatSignalFrame = typeof ChatSignalFrame.Type

/** Client → server chat frame: "I am typing". Carries no user id (the socket's user is stamped by the server). */
export const ChatTypingFrame = Schema.Struct({ type: Schema.Literal("minga.typing") })
export type ChatTypingFrame = typeof ChatTypingFrame.Type
// #endregion chat-signals
